/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum BrowserOsTypes {
    Windows = 'windows',
    MacOs = 'macos',
    ChromeOs = 'chrome os',
    iOS = 'ios',
    Linux = 'linux',
    WebOS = 'webos'
}

// Rename to CommonDeviceType to avoid duplicate identifer from PlatformAPI.DeviceType
export enum CommonDeviceType {
    Desktop = 'Desktop',
    Laptop = 'Laptop',
    TV = 'TV',
    Phone = 'Phone',
    Tablet = 'Tablet',
    Server = 'Server',
    Console = 'Console',
    HMD = 'HMD',
    Undefined = 'undefined'
}

export enum DeviceOSType {
    Windows = 'Windows',
    MacOS = 'MacOS',
    Shield = 'Shield',
    FireOS = 'FireOS',
    Android = 'Android',
    IOS = 'iOS',
    IPadOS = 'iPadOS',
    ChromeOS = 'ChromeOS',
    Linux = 'Linux',
    Tizen = 'Tizen',
    WebOS = 'WebOS',
    TvOS = 'tvOS',
    XBox = 'Xbox',
    SteamOS = 'SteamOS',
    VisionOS = 'visionOS',
    VegaOS = 'VegaOS',
    AluminiumOS = 'AluminiumOS',
    Undefined = 'undefined'
}

export enum BrowserType {
    CHROME = 'Chrome',
    SAFARI = 'Safari',
    YANDEX = 'Yandex',
    EDGE = 'Edge',
    EDGE_LEGACY = 'Edge_legacy',
    FIREFOX = 'Firefox',
    SAMSUNG = 'Samsung',
    CHROMIUM = 'Chromium',
    OPERA = 'Opera',
    BRAVE = 'Brave',
    SILK = 'Silk',
    Undefined = 'undefined'
}

export const Undefined = 'undefined';

/**
 * Parses a version string (e.g. "26.4.1") into a [major, minor, patch] tuple.
 * Returns null if the string cannot be parsed.
 */
export function parseVersion(version: string): [number, number, number] | null {
    const match = version?.match(/^(\d+(?:\.\d+)*)/);
    if (!match) {
        return null;
    }
    const parts = match[1].split('.').map(Number);
    if (parts.length < 2 || parts.some(isNaN)) {
        return null;
    }
    return [parts[0] ?? 0, parts[1] ?? 0, parts[2] ?? 0];
}

/**
 * Returns true if `actual` version is >= `baseline` version.
 */
export function isAtLeastVersion(actual: [number, number, number], baseline: [number, number, number]): boolean {
    if (actual[0] !== baseline[0]) return actual[0] > baseline[0];
    if (actual[1] !== baseline[1]) return actual[1] > baseline[1];
    return actual[2] >= baseline[2];
}
